import i18n from 'i18n';
import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

const fields: GenericFormItem[] = [
  {
    gridXs: 12,
    label: i18n.t('EMAIL_KEY'),
    stateKey: 'email',
    type: 'email',
    validateOnChange: true,
  },
];

export default fields;
